import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider
} from '@material-ui/core';
import {
  ArrowRight as ArrowRightIcon,
  ArrowDropDown as ArrowDropDownIcon
} from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import { data, options } from 'views/Dashboard/components/LatestSales/chart';

const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: { justifyContent: 'flex-end' }
}));

const LatestSales = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      <CardHeader
        title="Latest Sales"
        action={
          <Button
            size="small"
            variant="text"
          >
            Last 7 days <ArrowDropDownIcon />
          </Button>
        }
      />

      <Divider />

      <CardContent>
        <div className={classes.chartContainer}>
          <Bar
            data={data}
            options={options}
          />
        </div>
      </CardContent>

      <Divider />

      <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          Overview <ArrowRightIcon />
        </Button>
      </CardActions>
    </Card>
  );
};

LatestSales.propTypes = {
  className: PropTypes.string
};

export default LatestSales;